import { getSafeNextPath } from 'shared-helpers/common';

// helper for getting the next path from a url, ex. /login?next=/users
// the next path may also contain query params, and if we just use
// query.next it might drop some of the params, which is why
// we parse the full next path from asPath
const getNextPath = (asPath) => {
  if (!asPath) return null;
  return getSafeNextPath(asPath, null);
};

export default getNextPath;
